import { useSelector } from 'react-redux';
import { selectActivityContentLocale, selectActivityFromDetailState, selectReviewSortAndFilterMatrix } from 'component/page/detail/store/detail.selectors';
import { mapDescriptionFromContent, mapTitleFromContent } from 'gql/service/graph/activityService';
import { parseNumber } from 'core/utils/parseNumber';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { Schema, Types } from 'component/page/detail/SEOLdJson/SEOLdJson.types';
import { getReviewInfo } from 'component/page/detail/Review/ReviewSortAndFilter/ReviewSortAndFilter.utils';

export const useProductTypeJsonSchemaForSeo = (): Schema => {
    const activity = useSelector(selectActivityFromDetailState);
    const locale = useSelector(selectActivityContentLocale);
    const cms = useSelector(selectCmsFromBootstrap);
    const reviewMatrix = useSelector(selectReviewSortAndFilterMatrix);
    const reviewInfo = getReviewInfo(locale, cms, reviewMatrix);
    const title = mapTitleFromContent(activity.content);
    const description = mapDescriptionFromContent(activity.content);

    const schema: Schema = {
        '@context': 'https://schema.org/',
        '@type': Types.Product,
        name: title,
        description,
        aggregateRating: {
            '@type': Types.AggregateRating,
            ratingValue: parseNumber(reviewInfo.averageScore),
            reviewCount: reviewInfo.totalReview,
        },
    };

    return schema;
};
